import SaitoPeer from 'saito-js/lib/peer';

export default class Peer extends SaitoPeer {
  constructor(data: any, publicKey?: string) {
    super(data, publicKey);
  }
}
